import { render, staticRenderFns } from "./SupportCalculator.vue?vue&type=template&id=40532f5f&scoped=true"
import script from "./SupportCalculator.vue?vue&type=script&lang=js"
export * from "./SupportCalculator.vue?vue&type=script&lang=js"
import style0 from "./SupportCalculator.vue?vue&type=style&index=0&id=40532f5f&prod&scoped=true&lang=css"
import style1 from "./SupportCalculator.vue?vue&type=style&index=1&id=40532f5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40532f5f",
  null
  
)

export default component.exports